const TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID
const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
const trackPageView = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production' && TRACKING_ID) {
    window.gtag('config', TRACKING_ID)
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
const trackEvent = (action: string, label?: string) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    window.gtag('event', action, {
      event_label: label
    })
  } else {
    console.log('Log Event', action, {
      event_label: label
    })
  }
}

const trackAdsLead = (action: string) => {
  if(process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    window.gtag('event', action, {'send_to': `${GOOGLE_ADS_ID}/SU-5CJ6RsKgYEM3vqMYo`})
  }
}

const gtag = {
  TRACKING_ID,
  GOOGLE_ADS_ID,
  trackPageView,
  trackEvent,
  trackAdsLead
}

export default gtag
